import { City } from "../store/types";

export const cities: City[] = [
  {
    name: "Ottawa",
    latitude: 45.424721,
    longitude: -75.695,
  },
  {
    name: "Moscow",
    latitude: 55.751244,
    longitude: 37.618423,
  },
  {
    name: "Tokyo",
    latitude: 35.672855,
    longitude: 139.817413,
  },
];
